import { Injectable } from '@angular/core';
import { GatewayClientProvider } from '../gateway-client/gateway-client';

@Injectable()
export class ProfileProvider {

  constructor(public gt: GatewayClientProvider) { }

  update(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gt.UpdateProfile(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //<<<--------====<<(For Update PhoneNumber or Email Address.)>>====------->>>//
  UpdateEmailAndPhonenumber(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gt.UpdateEmailAndPhonenumber(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //<<<--------====<<(For Sending OTP on PhoneNumber or Email Address.)>>====------->>>//
  SendOtp(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gt.SendOtpOnPhoneOrEmail(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //<<<--------====<<(For Update Address Details.)>>====------->>>//
  UpdateAddressDetails(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gt.UpdateAddressDetails(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/profile/profile.ts